import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-custom mt-2" }
const _hoisted_2 = { class: "p-field-label mt-3" }
const _hoisted_3 = { class: "list-unstyled" }
const _hoisted_4 = { class: "mt-3 d-flex align-items-center" }
const _hoisted_5 = { class: "px-2 custom-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KeypadCodeInput = _resolveComponent("KeypadCodeInput")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ElScrollbar, { class: "details-panel-content-wrapper" }, {
      default: _withCtx(() => [
        _createVNode(_component_KeypadCodeInput, {
          disabled: !_ctx.currentEntrancePlant.syncStatus?.canEditWithPropagation,
          modelValue: _ctx.keypadCode,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keypadCode = $event)),
          alreadyUsedCodes: _ctx.alreadyUsedCodes,
          label: _ctx.$t('AppResourceEP.KeypadCodePlaceHolder'),
          keypadCodeRequiredLength: _ctx.currentEntrancePlant.keypadCodeRequiredLength,
          onErrorKeyCode: _ctx.handleErrorKeyCode,
          onKeyCodeEdited: _ctx.handleKeypadCodeEdited
        }, null, 8, ["disabled", "modelValue", "alreadyUsedCodes", "label", "keypadCodeRequiredLength", "onErrorKeyCode", "onKeyCodeEdited"]),
        _createVNode("div", null, [
          _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction")), 1),
          _createVNode("ul", _hoisted_3, [
            _createVNode("li", null, _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction_Lenght", [_ctx.currentEntrancePlant.keypadCodeRequiredLength])), 1),
            _createVNode("li", null, _toDisplayString(_ctx.$t(
                                "AppResourceEP.AccessCodeInstruction_Different"
                            )), 1),
            _createVNode("li", null, _toDisplayString(_ctx.$t(
                                "AppResourceEP.AccessCodeInstruction_Consecutive"
                            )), 1),
            _createVNode("li", null, _toDisplayString(_ctx.$t(
                                "AppResourceEP.AccessCodeInstruction_SameNumber"
                            )), 1)
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_InlineSvgScoped, {
            class: "svg-icon",
            src: 
                        require(`@/assets/images/icons/icon-alert-medium-outline.svg`)
                    ,
            "aria-label": "icon-badge"
          }, null, 8, ["src"]),
          _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("AppResourceEP.ChangeAccessCodeLengthInfo")), 1)
        ])
      ]),
      _: 1
    })
  ]))
}